import React, { useEffect } from 'react';
import useDashboardStore from '../../store/builders/useDashboardStore';

const CardTile = () => {
  const { cardTile, isLoading, getCardTile } = useDashboardStore();

  useEffect(() => {
    getCardTile();
  }, [getCardTile]);

  if (isLoading) {
    return (
      <div className="flex items-center justify-center">
        <div className="relative bg-gradient-to-br rounded-lg p-2 w-80 h-48 flex items-center justify-center">
          <div className="animate-spin rounded-full h-12 w-12 border-t-4 border-blue-500"></div>
        </div>
      </div>
    );
  }

  return (
    <div className="flex items-center justify-center w-full">
      <div 
        className="relative bg-gradient-to-br rounded-lg p-2 w-full max-w-[320px] sm:max-w-[340px] md:max-w-[360px] lg:max-w-[380px] overflow-hidden cursor-pointer transform transition-all duration-300 hover:scale-[1.02] active:scale-[0.98]" 
        style={{ 
          backgroundColor: "#D0D0D0",
          boxShadow: "rgba(50, 50, 93, 0.25) 0px 13px 27px -5px, rgba(0, 0, 0, 0.3) 0px 8px 16px -8px",
          transition: "all 0.3s ease-in-out"
        }}
        onClick={() => {
          // Add your click handler here
        }}
        onMouseEnter={(e) => {
          e.currentTarget.style.boxShadow = "rgba(50, 50, 93, 0.35) 0px 30px 60px -12px, rgba(0, 0, 0, 0.4) 0px 18px 36px -18px";
        }}
        onMouseLeave={(e) => {
          e.currentTarget.style.boxShadow = "rgba(50, 50, 93, 0.25) 0px 13px 27px -5px, rgba(0, 0, 0, 0.3) 0px 8px 16px -8px";
        }}
        onMouseDown={(e) => {
          e.currentTarget.style.boxShadow = "rgba(50, 50, 93, 0.15) 0px 6px 12px -2px, rgba(0, 0, 0, 0.2) 0px 3px 7px -3px";
        }}
        onMouseUp={(e) => {
          e.currentTarget.style.boxShadow = "rgba(50, 50, 93, 0.25) 0px 13px 27px -5px, rgba(0, 0, 0, 0.3) 0px 8px 16px -8px";
        }}
      >
        <div className="flex justify-between items-start mb-4">
          <div>
            <img src="/assets/black logo.png" alt="Ducktail Logo" className="h-4" />
          </div>
          <div className="flex flex-col items-end gap-0.5">
            <span className="text-[10px] font-medium tracking-wide text-gray-800">LICENSE CARD</span>
            <span className={`bg-${cardTile?.status === 'active' ? 'green' : 'red'}-500 text-white text-[10px] px-2 py-0.5 rounded`}>
              {cardTile?.status || 'Unknown'}
            </span>
          </div>
        </div>

        <div className="relative">
          <div className="mb-4">
            <h1 className={`font-bold text-gray-900 mb-0.5 tracking-wide ${
              cardTile?.company_name && cardTile.company_name.length > 20 
                ? 'text-lg' 
                : 'text-xl'
            }`}>
              {cardTile?.company_name || 'N/A'}
            </h1>
            <p className="text-sm text-gray-700 tracking-wider truncate">{cardTile?.company_id || 'N/A'}</p>
          </div>

          <div className="flex items-center gap-4">
            <img src="/assets/Ducktail-02.png" alt="Bottom Left Logo" className="h-8" />
            <p className="text-xs pt-4 text-gray-700 tracking-wide">
              Valid Upto - {cardTile?.validity_end_date ? new Date(cardTile.validity_end_date).toLocaleDateString() : 'N/A'}
            </p>
          </div>

          <div className="absolute top-0 right-0 w-1/2 h-full flex justify-end items-end opacity-85">
            <img src="/assets/image 1.png" alt="Map Design" className="object-contain" style={{ transform: 'scale(1.5) translateX(22%) translateY(20%)' }} />
          </div>
        </div>
      </div>
    </div>
  );
};

export default CardTile;
